var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.341 6.66669L25.8321 15.3334L13.341 24V6.66669ZM9.82545 6.66669V24H6.66669V6.66669H9.82545Z",
    fill: "#ACCAF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayPause);
export default __webpack_public_path__ + "static/media/PlayPause.a16a3c5c78c912bf03fe680ad195f648.svg";
export { ForwardRef as ReactComponent };